import axios from "axios";
import {
	Message,
	Loading
} from "element-ui";
import store from "@/store";
import {
	getToken,
	getTenant
} from "@/utils/auth";
import md5 from "js-md5";
import { encryptionObj } from '@/utils/crypto'
import { nonceStr } from '@/utils/util'

const { NODE_ENV } = process.env

const { VUE_APP_API_URL } = process.env

let loadingInstance, timer, resTimer;

const service = axios.create({
  	timeout: 100000 // request timeout
});
service.defaults.validateStatus = function(status) {
  	return status >= 0 && status <= 5000; // 默认的
};

service.interceptors.request.use(
  config => {
    const { mockBaseUrl, baseURL } = store.state

    // 有noLoading字段并且值为true时，不显示loading样式
    if (!timer && config.url != "/tcp/v1/machine/state" && !config.noLoading) {
      timer = setTimeout(() => {
        loadingInstance = Loading.service({
          fullscreen: true,
          text: "请稍等"
        });
      }, 300)
    }
    // 密码、手机号、身份证号加密（api里有encryption属性时，把encryption的值传给加密方法）
    if(config.encryption && config.data.content) {
      // 加密
      config.data.content = encryptionObj({ ...config.data.content }, config.encryption )
    }

    // let domain = window.location.hostname;
    // config.baseURL = baseURL

	if(NODE_ENV == 'development') {
		// Apifox mock
      	if(mockBaseUrl && config.mock) config.baseURL = mockBaseUrl
		else config.baseURL = baseURL
	} else {
		if (VUE_APP_API_URL) config.baseURL = VUE_APP_API_URL + (VUE_APP_API_URL.endsWith('/') ? '' : '/') + 'tengyun-api'
		else config.baseURL = location.origin + '/tengyun-api'
	}
    // if (NODE_ENV == "production") {

    //   if (window.location.port) config.baseURL = window.location.protocol + "//" + domain + ":" + window.location.port;
    //   else config.baseURL = window.location.protocol + "//" + domain;
    // }

    // if(NODE_ENV == 'development') {
    //   // Apifox mock
    //   if(mockBaseUrl && config.mock) config.baseURL = mockBaseUrl
    // }

	
    // if(NODE_ENV != 'development') {
	// 	config.baseURL = config.baseURL + '/tengyun-api'
    // }

	// if (VUE_APP_API_URL) config.baseURL = VUE_APP_API_URL

    if (config.url != "/oauth/web/token") {
		let data;
		if(config.method == 'get') data = config.params
		else if(config.data == "string") data = JSON.parse(config.data)
		else data = config.data

		data.nonceStr = nonceStr(6)
		data.timestamp = Date.now()
		data.sign = getSign(data)

		if(config.method != "get" && typeof config.data == "string") config.data = JSON.stringify(data)
    }

    if (getTenant() && config.url != '/datascreen/getdatascreen') {
      config.headers["MERCHANT-ID"] = getTenant();
    }
    if (config.url == '/datascreen/getdatascreen') {
      let arr = config.data.content.authorityId.split("&");
      console.log(arr);
      config.headers["MERCHANT-ID"] = arr[0].split("=")[1]
      if (arr[1]) {
        config.data.content.authorityId = arr[1].split("=")[1]
      } else {
        delete config.data.content.authorityId
      }
    }
    if (store.getters.token) {
      if (config.headers.Authorization) return config;
      config.headers["X-Token"] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
const getSign = data => {
	let str = 'content=' + JSON.stringify(data.content)
		str += '&nonceStr=' + data.nonceStr
		str += '&signType=md5'
		str += '&timestamp=' + data.timestamp
		str += '&version=' + data.version
		str += '&key=xnznkjln'
	return md5(str).toLocaleUpperCase()
}
// 清楚计时器和Loading
const clearResTimerAndLoading = () => {
    if (resTimer) {
      clearTimeout(resTimer)
      resTimer = null
    }
    resTimer = setTimeout(() => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      if (loadingInstance) {
        loadingInstance.close()
        loadingInstance = null
      }
      resTimer = null
    }, 100)
  }
  // response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {

    clearResTimerAndLoading()

    console.log("response=======", response)
    if (response.status === 401) {
      // to re-login
      Message({
        message: "登录失效，请重新登录",
        type: "error",
        duration: 10 * 1000
      });
      setTimeout(() => {
        store.dispatch("user/resetToken").then(() => {
          location.reload();
        })
      }, 100)

      return Promise.reject(res.msg || "Error");
    }



    const res = response.data;

    if (res.repCode) {
        return res
    }

    if (res.size && res.type == "application/json") {
      // 导出报错
      handlerResponseError(res)

      return Promise.reject();
    }
    if (res.size && res.type != "application/json") {
      return res;
    }
    if (res.code == 59000 && !response.config.url.includes('registerFace')) {
      return res;
    }
    if (res.code == 20001) {
      // to re-login
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 2 * 1000
      });
      store.dispatch("user/resetToken").then(() => {
        location.reload();
      });
      return Promise.reject(res.msg || "Error");
    }
    // // if the custom code is not 20000, it is judged as an error.
    // if (!res.code) return res
    if (res.code != 10000) {
      Message({
        message: res.msg || res.data || "Error",
        type: "error",
        duration: 4 * 1000
      });
      return Promise.reject(res.msg || res.data || "Error");
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    }
    // if (res.code == "10000") {
    //   Message({
    //     message: res.msg || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject(new Error(res.msg || 'Error'))
    // }
    if (response.headers["x-token"]) res.data.x_token = response.headers["x-token"]
    return res.hasOwnProperty('data') ? res.data : res;
    // // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //
    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;

    // } else {
    //   return res
    // }
  },
  error => {
    clearResTimerAndLoading()

    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

function handlerResponseError(data) {
  const fileReader = new FileReader();
  fileReader.onload = function() {
    try {
      const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
      Message({
        message: jsonData.msg || "导出错误!",
        type: "error",
        duration: 2 * 1000
      });
    } catch (err) { // 解析成对象失败，说明是正常的文件流
      console.log('success...')
    }
  };
  fileReader.readAsText(data);
}

export default service;
